export class DestinationStrings {
  static introTitle = 'Move your data from any Source to a Destination in near real-time';

  static introDescription =
    'Get data in your Destinations in near real-time and easily track data loading progress.';
}
